import {
  getSourceOptions,
  resolveSourceValue,
} from './getAlgorithmTargetRuleSourceOptions';
import {
  getTargetOptions,
  resolveTargetValue,
} from './getAlgorithmTargetRuleTargetOptions';
import type { AlgorithmTargetMappingOptionsProps } from './types';

export const getAlgorithmTargetRuleOptions = ({
  algorithmTypeCode,
  dataObjectVersion,
  confidentialityStatusCode,
  subjectAttributeCodes,
  targetDimensionsAndIndicatorsByCode,
  sources,
  mappings,
  currentSourceValue,
  currentTargetValue = [],
}: AlgorithmTargetMappingOptionsProps) => {
  const sourceValue = resolveSourceValue(
    currentSourceValue,
    subjectAttributeCodes,
    mappings,
  );
  const targetValue = resolveTargetValue(
    currentTargetValue,
    targetDimensionsAndIndicatorsByCode,
  );

  const { sourceOptions, sourceDimensionsAndIndicatorsByCode } =
    getSourceOptions({
      algorithmTypeCode,
      dataObjectVersion,
      targetValue,
      sources,
      mappings,
    });

  const targetOptions = getTargetOptions({
    algorithmTypeCode,
    dataObjectVersion,
    sourceValue,
    targetValue,
    targetDimensionsAndIndicators: targetDimensionsAndIndicatorsByCode.values(),
    sourceDimensionsAndIndicatorsByCode,
    confidentialityStatusCode,
  });

  return { sourceOptions, targetOptions };
};
